import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import { USDollar } from '../../../../utilities/number';
import "./MissMFC.linaria.module.css!=!./MissMFC?./MissMFC.linaria.module.css?css=H4sIAAAAAAAAA2WQ2Y4CIRRE3/0S5wHT7TILfgwBvCyGvnTg2ovEfzeatBHn8SSnKpXaSOqE0aJ13/F8uW5qLOdLJm9mpiMSIHENSJCOt9VTdFXsRUUGb5F5gi5/JHQWyqCNpqZiIhIbwVtH/NA0i/6XRUvT6IdQTj73Qc7cBJje2n5x125VTVWbiuG0+D9BtDj5yQ1FxxATH2RaM2YTALLO6K9FtFcxu32jTE2lk8l6ZAEM8W3/2vE4bFZ7DP0H/vsv91IDU0AjAB5vqzuDmdznfwEAAA=="
const rootStyles = "atm_fc_1h6ojuz atm_h_1h6ojuz atm_cs_bfngof atm_9s_1txwivl";
const rankStyles = "atm_cs_8n312b";
const prizeStyles = "atm_7l_1nxixhv atm_cs_8n312b atm_gz_yh40bf";
const stylesSpaceBetween = "atm_fc_1yb4nlp";
interface MissMFCBannerProps {
  missMFCPrize?: number;
  missMFCRank: number;
  rankStyle?: CSSProperties;
  rankClassName?: LinariaClassName;
  className?: LinariaClassName;
  style?: CSSProperties;
  text?: string;
}
const MissMFCBanner = memo((props: MissMFCBannerProps) => {
  const {
    text = 'Miss MFC',
    rankClassName,
    missMFCPrize,
    missMFCRank,
    className,
    rankStyle,
    style
  } = props;
  return <div className={cx(rootStyles, className, missMFCPrize && stylesSpaceBetween)} style={style}>
            <div data-testid="Container__MissMFCRank">
                <span>{text}</span>
                <span className={cx(rankStyles, rankClassName)} data-testid="Label__MissMFCRank" style={rankStyle}>
                    #{missMFCRank}
                </span>
            </div>
            {missMFCPrize && <div>
                    <span>Prize:</span>
                    <span data-testid="Label__MissMFCPrize" className={prizeStyles}>
                        {USDollar.format(missMFCPrize).replace('.00', '')}
                    </span>
                </div>}
        </div>;
});
export default MissMFCBanner;
export { MissMFCBanner };